import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getApp } from "firebase/app";

const FirebaseStayLoan = () => {
  const location = useLocation();
  const app = getApp("ohyaFinanceFirebase");
  const analytics = getAnalytics(app);
  const [startTime, setStartTime] = useState(Date.now());

  useEffect(() => {
    if (location.pathname === "/") {
      // Set the start time when user enters the /intro page
      setStartTime(Date.now());

      const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
          const endTime = Date.now();
          const stayTime = (endTime - startTime) / 1000; // Convert to seconds

          if (stayTime >= 10) {
            logEvent(analytics, "finance_loan_time_stay", {
              time_length: stayTime,
              page_location: "https://www.ohyagroup.com",
            });
          }
        }
      };

      // Add event listener for visibility change
      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        // Remove event listener when the component is unmounted or path changes
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };
    }
  }, [location, analytics, startTime]);

  return null;
};

export default FirebaseStayLoan;
